document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.custom-formulated').forEach(function (section) {
    var tabs = section.querySelectorAll('[data-tab-target]');
    var panels = section.querySelectorAll('.custom-formulated__panel');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          t.classList.remove('is-active');
        });
        panels.forEach(function (p) {
          p.classList.remove('is-active');
        });
        tab.classList.add('is-active');
        var target = document.getElementById(tab.getAttribute('data-tab-target'));
        if (target) target.classList.add('is-active');
      });
    });

    panels.forEach(function (panel) {
      var track = panel.querySelector('[data-tab-track]');
      var prevBtn = panel.querySelector('[data-tab-prev]');
      var nextBtn = panel.querySelector('[data-tab-next]');
      if (!track) return;

      function scrollByCard(direction) {
        var card = track.querySelector('.custom-formulated__card');
        if (!card) return;
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || 0);
        var amount = (card.offsetWidth + gap) * direction;
        track.scrollBy({ left: amount, behavior: 'smooth' });
      }

      function updateNavState() {
        if (!prevBtn && !nextBtn) return;
        var maxScroll = track.scrollWidth - track.clientWidth;
        if (prevBtn) prevBtn.disabled = track.scrollLeft <= 2;
        if (nextBtn) nextBtn.disabled = track.scrollLeft >= maxScroll - 2;
      }

      track.addEventListener('scroll', updateNavState);
      window.addEventListener('resize', updateNavState);
      updateNavState();

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          scrollByCard(-1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          scrollByCard(1);
        });
      }
    });
  });
});